import React from "react";
import "./AFButton.scss";

import Button from "../../../Form/Button/Button";

const AFButton = ({ submitHandler, loading, text }) => {
  return (
    <div id='CarrierSubscribeFormFooter'>
      <Button title={text} onClick={submitHandler} loading={loading} />
    </div>
  );
};

export default AFButton;
